import React, { useState } from 'react';
import '../../assets/css/ForgetPassword.css';
import Form from 'react-bootstrap/Form';
import { Button, Col, Container, Row } from 'react-bootstrap';
import { WebApiCalls } from '../../webApiCalls/WebApiCalls';
import { useNavigate } from 'react-router-dom';

const ForgetPassword = () => {
    const navigate = useNavigate()
    const [email, setEmail] = useState("")

    const handleSubmit = (e) => {
        e.preventDefault()

        if (email) {
            const obj = {
                email
            }
            new WebApiCalls().forgetPassword(obj)
                .then(res => {
                    if (res?.code == 200) {
                        navigate('/verify-password', { state: { email } })
                    }
                })
                .catch(err => { })
        }
    }

    return (
        <Container fluid>
            <Row className="align-items-center">
                {/* Image section */}
                <Col className="px-0 col-lg-6 col-md-12 col-sm-12">
                    <div className="forget-bg">
                        <div className="f-header">
                            <p>Earn</p>
                            <p>Points While</p>
                            <span>Travelling</span>
                        </div>
                    </div>
                </Col>
                {/* Input Section */}
                <Col lg={6} md={9} sm={12} className="mx-auto">
                    <div className="forget-pass-wrapper mx-auto mt-4 mt-sm-0">
                        <div className="forget-title mb-5 mt-5 mt-lg-0">
                            <p className=''>
                                Forgot <strong>Password?</strong>
                            </p>
                        </div>
                        <Form onSubmit={handleSubmit}>
                            <div className="mb-5">
                                <Form.Control value={email} className="forget-pass-mail" type="email" id="text" aria-describedby="passwordHelpBlock" placeholder="Williambenjamin@gmail.com"
                                    onChange={e => setEmail(e.target.value)} required />
                            </div>
                            {/* Send Button */}
                            <div className="">
                                <Button type='submit' bsPrefix="code-btn" variant="primary" size="lg">
                                    SEND CODE
                                </Button>
                            </div>
                        </Form>
                    </div>
                </Col>
            </Row>
        </Container>
    );
};

export default ForgetPassword;
